import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { fetchWebCountry, saveWebCountry } from '../../actions/web-countries';
import { fetchCountries } from '../../actions/countries';
import { resetError } from '../../actions/errors';
import WebCountryForm from './form';

class WebCountryEdit extends React.Component {
  componentWillMount() {
    this.props.getWebCountry();
    this.props.getCountries();
  }

  render() {
    const {
      countries, country, goToShow, resetErrorAction, saveAction,
    } = this.props;
    if (!country || Object.keys(country).length === 0) return null;
    const submit = (body) => {
      resetErrorAction();
      return saveAction(body).then((result) => {
        if (result.ok) goToShow();
        return result;
      });
    };
    return (
      <WebCountryForm
        countries={countries}
        country={country}
        title={`Edit web country: ${country.id}`}
        submitLabel="Save"
        onSubmit={submit}
        cancel={goToShow}
      />
    );
  }
}

WebCountryEdit.propTypes = {
  countries: PropTypes.arrayOf(PropTypes.object),
  country: PropTypes.shape({}),
  getCountries: PropTypes.func.isRequired,
  getWebCountry: PropTypes.func.isRequired,
  goToShow: PropTypes.func.isRequired,
  resetErrorAction: PropTypes.func.isRequired,
  saveAction: PropTypes.func.isRequired,
};

WebCountryEdit.defaultProps = { countries: [], country: {} };

const mapStateToProps = ({ countries, webCountries }) => ({
  countries: countries.items,
  country: webCountries.item,
});
const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
  getCountries: () => fetchCountries(),
  getWebCountry: () => fetchWebCountry(ownProps.match.params.id),
  goToShow: () => push(`/web-countries/${ownProps.match.params.id}`),
  resetErrorAction: () => resetError(),
  saveAction: body => saveWebCountry(ownProps.match.params.id, body),
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WebCountryEdit);
